/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/jump_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M12 16h4v1h-4zM6 16h4v1H6z"/><path pid="1" d="M23.536 12.258l-3.535 3.535-3.535-3.535-.707.707 3.535 3.535-3.537 3.535.707.707 3.537-3.535 3.535 3.535.707-.707-3.535-3.535 3.535-3.535z"/><path pid="2" d="M10 17H6v-1h4v1zm2-1h4v1h-4v-1zm12.243 4.035l-.707.707-3.535-3.535-3.537 3.535-.707-.707 3.537-3.535-3.535-3.535.707-.707 3.535 3.535 3.535-3.535.707.707-3.535 3.535 3.535 3.535z"/>'
  }
})
